import { useCallback, useMemo } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { serializeFilters } from '@user/components/Filters'
import {
  saveFilterPreference,
  selectAllFilterPreferences,
} from '@user/store/userPreferences'
import { useSelector } from 'react-redux'
import { ILead, LeadFilterSet } from '@user/store/lead'
import { useSaveGuestUserLeadsFilterSet } from '@user/store/guestUser'

export const useSaveLeadFilters = () => {
  const dispatch = useAppDispatch()
  const saveFilters = useSaveGuestUserLeadsFilterSet()
  const prefs = useSelector(selectAllFilterPreferences)

  const leadPref = useMemo(
    () => prefs.find((p) => p.type === 'guestUserDashboardLeads'),
    [prefs],
  )

  return useCallback(
    (model: LeadFilterSet) => {
      dispatch(
        saveFilterPreference({
          id: leadPref?.id,
          type: 'guestUserDashboardLeads',
          name: 'guestUserDashboardLeads filters',
          filter: serializeFilters<ILead, LeadFilterSet>(model),
        }),
      )

      saveFilters(model)
    },
    [dispatch, leadPref?.id, saveFilters],
  )
}
